// extracted by mini-css-extract-plugin
export default {"action":"skills_action__P36Ae","skillsList":"skills_skillsList__Iug7G","chip":"skills_chip__DFe8Z"};